import React from "react";

export const ChatThinking: React.FC = () => {
	return (
		<div className="box-border flex w-[384px] flex-col items-start gap-2 py-1 pl-0 pr-20 duration-200 animate-in fade-in slide-in-from-bottom-2">
			<div className="flex max-w-full items-end gap-2">
				{/* Avatar */}
				<img src="/static/img/py-logo/py-round-icon.svg" alt="PerformYard" className="h-8 w-8 shrink-0" />

				{/* Thinking indicator */}
				<div className="rounded-2xl rounded-bl-sm bg-[#E8EEF2] px-4 py-3">
					<span className="text-sm text-neutral-600">Thinking...</span>
				</div>
			</div>
		</div>
	);
};

export default ChatThinking;
